import { MovimientosObraService } from './../../services/movimientos-obra.service';
import { AutenticacionService } from './../../services/autenticacion.service';
import { PrintReciboModalComponent } from './../partials/print-recibo-modal/print-recibo-modal.component';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import { ValidatorService } from '../../services/tools/validator.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import {MovimientosObraProyeccionesService} from '../../services/movimientos-obra-proyecciones.service';
import {ObrasService} from "../../services/obras.service";
import {CuentasService} from "../../services/cuentas.service";
import {ConceptosService} from "../../services/conceptos.service";
import {ProveedoresService} from "../../services/proveedores.service";
import {HelpersService} from "../../services/tools/helpers.service";
import {WarningModalComponent} from "../tools/modals/warning-modal/warning-modal.component";
import {Globals} from './../../services/tools/Globals.service';
import { MovimientosModalComponent } from '../movimientos-obra/movimientos-modal/movimientos-modal.component';
declare var $;

@Component({
  selector: 'app-movimientos-obra-proyecciones',
  templateUrl: './movimientos-obra-proyecciones.component.html',
  styleUrls: ['./movimientos-obra-proyecciones.component.scss']
})
export class MovimientosObraProyeccionesComponent implements OnInit {

  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(WarningModalComponent) warningModal: WarningModalComponent;
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;
  @ViewChild(PrintReciboModalComponent) printReciboModal: PrintReciboModalComponent;
  @ViewChild(MovimientosModalComponent) movimientosModal: MovimientosModalComponent;

  movimientosObra: any[];
  totales: any;
  searchText: string = "";
  mostrarListado: boolean = true;
  errors: any = {};
  searchProcess: any;
  paginate: any = {};
  fechaActual: string;
  currentPage: any = 1;
  lastPage: any = 1;
  processing: any = false;
  alterTable: any = 'starting';
  securityActived: any = false;
  exportingCSV: any = false;
  /* selected */
  movimientosObraSelected: any;
  conceptosSelectedOptions: any = [];
  cuentasSelectedOptions: any = [];
  proveedoresSelectedOptions: any = [];
  /* filters */
  obraFilter: any = {};
  obraFilterOptions: any[];
  cuentasFilter: any = [];
  cuentasFilterOptions: any[];
  cuentasFilterOptionsTraspasos: any[];
  conceptosFilter: any = [];
  conceptosFilterOptions: any[];
  proveedoresFilter: any = [];
  proveedoresFilterOptions: any[] = [];
  tipoProveedorFilter: any = {};
  tipoProveedorFilterOptions: any[];
  fechaInicialFilter: any;
  fechaFinalFilter: any;

  isNew: any = false;
  validEdit: any = true;
  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  //Proyecciones
  movimientosObraProyecciones : any = false;
  //ACTIVAR CLASS PROYECCIONES
  public activeNoValid : any;
  private nipValid = {active:true};
  private activeProjections : any = {active:true}

  private passwordActived:any;


  constructor(  private movimientosObraProyeccionesService: MovimientosObraProyeccionesService,
                private obrasService: ObrasService,
                private cuentasService: CuentasService,
                private conceptosService: ConceptosService,
                private proveedoresService: ProveedoresService,
                private validatorService: ValidatorService,
                private helperService: HelpersService,
                private authService: AutenticacionService,
                private globals: Globals) {
    // se colocó esto para que el this dentro de delete sea el del scope global
    this.getFechaActual();
    this.getFilters();
    this.resetMovimientosObraSelected = this.resetMovimientosObraSelected.bind(this);
    this.deleteMovimientoObra = this.deleteMovimientoObra.bind(this);
    this.activeNoValid = {nipValid:true};
    this.activeProjections = true;

    //proyecciones
    this.sendProyeccionesMovimientosObra = this.sendProyeccionesMovimientosObra.bind(this);
    this.sendMovimientosObraToProyecciones = this.sendMovimientosObraToProyecciones.bind(this);
    this.passwordActived = globals.passwordActivate;
  }

  ngOnInit() {
    this.active();
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }

  active(){
    if(this.passwordActived){
      this.securityActived = true;
    }
    else{
      this.securityActived = false;
    }
    if(this.authService.auth_user.key)
    {
      this.securityActived = true;
    }
    else
    {
      this.securityActived = false;
    }
  }

  resetMovimientosObraSelected() {
    this.movimientosObraSelected = undefined;
    this.errors = {};
  }

  startMovimientosObraSelected() {
    this.resetMovimientosObraSelected();
    this.movimientosObraSelected = this.movimientosObraProyeccionesService.getDefaultSchedule();
    this.movimientosObraSelected.fechaMovimiento = this.fechaActual;
    this.changeTipoMovimiento( this.movimientosObraSelected.tipoMovimiento );
  }

  //Movimientos Obra	desactiva: enviar a movimientos y sus variables
  startMovimientosObraProyecciones(){
  	this.activeProjections = false;
  }
  startMovimientosObra(){
  	this.activeProjections = true;
  }

  selectMovimientosObra(movimientosObra) {
    console.log("El movimiento de obra es = ---------->>>>>>>>>> ",movimientosObra);
    if(movimientosObra !== undefined)
    {
      this.resetMovimientosObraSelected();
      this.isNew = false;
      const movimientosObraCloned = JSON.parse(JSON.stringify( movimientosObra ));
      this.movimientosObraSelected = movimientosObraCloned;
      this.changeObraSelected();
      if (this.movimientosObraSelected.conceptos.traspaso == 1) {
        this.changeTipoMovimiento( 4 );
      } else {
        this.changeTipoMovimiento( this.movimientosObraSelected.tipoMovimiento );
      }
      this.validEditAndDeleteMovimiento();
    }
  }

  SelectedMovimientosObraClass(movimientosObra) {
    return (this.validatorService.required(this.movimientosObraSelected) &&
        this.movimientosObraSelected.folio == movimientosObra.folio &&
        this.movimientosObraSelected.idMovimientos == movimientosObra.idMovimientos) ? 'active' : '';
  }
  
  searchMovimientosObra(page = null) {
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }
    if (this.searchText.length > 1) {
      this.getTotales();
      this.searchProcess = this.movimientosObraProyeccionesService.searchMovimientosObraWithFilters(this.searchText, this.getFiltersData(), page)
          .subscribe(response => {
            const content = response.json().content;
            this.movimientosObra = content.data;
            this.searchProcess = false;
            this.startPaginate(content);
            this.alterTable = (this.movimientosObra.length > 0)? false: 'not_found';
          }, (error) => {
            // se resuelven errores 403 y 500
            this.helperService.httpGlobalError(error);
          });
    } else {
      this.getMovimientosObra(1);
    }
  }

  getFechaActual() {
    this.movimientosObraProyeccionesService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          this.fechaActual = content.fecha;
          this.fechaInicialFilter = this.helperService.substract_days(content.fecha, 30);
          this.fechaFinalFilter = content.fecha;
          this.getMovimientosObra(); // se inicia la carga del listado general
        }, (error) => {
          // se resuelven errores 403 y 500
          this.helperService.httpGlobalError(error);
        });
  }

  getTotales() {
    this.movimientosObraProyeccionesService.getTotales(this.getFiltersData())
      .subscribe((response) => {
        const respuesta = response.json();
        this.totales = respuesta.content;
      }, (error) => {
        // se resuelven errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  getMovimientosObra(page = null) {
    this.getTotales();
    this.searchProcess = this.movimientosObraProyeccionesService.getMovimientosObraWithFilters(this.getFiltersData(), page)
        .subscribe(response => {
          const content = response.json().content;
          this.movimientosObra = content.data;
          this.startPaginate(content);
          this.searchProcess = false;
          this.alterTable = (this.movimientosObra.length > 0)? false: 'not_result';
          if(this.movimientosObra.length > 0)
          {
            this.selectMovimientosObra(this.movimientosObraSelected);
            
            console.log("datos this.validEdit", this.validEdit);
          }
          console.log("datos proyecciones", this.movimientosObra);
        }, (error) => {
          // se resuelven errores 403 y 500
          this.helperService.httpGlobalError(error);
        });
  }
  createMovimientosObra() {
    this.errors = [];
    this.errors = this.movimientosObraProyeccionesService.validateMovimientosObra(this.movimientosObraSelected);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    console.log('proveedores founded ', this.movimientosObraSelected.proveedores);
    this.processing = true;
    this.movimientosObraSelected.idCuentas = this.movimientosObraSelected.cuentas.idCuentas;
    this.movimientosObraSelected.idConceptos = this.movimientosObraSelected.conceptos.idConceptos;
    this.movimientosObraSelected.idObras = this.movimientosObraSelected.obras.idObras;
    this.movimientosObraSelected.numero = this.movimientosObraSelected.numero.toString();
    this.movimientosObraSelected.chequeCancelado = (this.movimientosObraSelected.chequeCancelado)? 1: 0;
    this.movimientosObraSelected.chequeConciliado = (this.movimientosObraSelected.chequeConciliado)? 1: 0;
    this.movimientosObraSelected.chequeTransferencia = (this.movimientosObraSelected.chequeTransferencia)? 1: 0;
    this.movimientosObraSelected.enviadoCfdi = (this.movimientosObraSelected.enviadoCfdi)? 1: 0;
    if (this.movimientosObraSelected.conceptos.traspaso == 1) {
      this.movimientosObraSelected.idCuentasDestino = this.movimientosObraSelected.cuenta_destino.idCuentas;
    } else if (this.movimientosObraSelected.conceptos.traspaso != 1 && this.validatorService.required(this.movimientosObraSelected.proveedores.idInversionistas)){
      console.log('se ha localizado inversionista ', this.movimientosObraSelected.proveedores.idInversionistas);
      this.movimientosObraSelected.idInversionistas = this.movimientosObraSelected.proveedores.idInversionistas;
      this.movimientosObraSelected.idProveedores = null;
    } else if (this.movimientosObraSelected.conceptos.traspaso != 1 && this.validatorService.required(this.movimientosObraSelected.proveedores.idProveedores)){
      console.log('se ha localizado proveedores', this.movimientosObraSelected.proveedores.idProveedores);
      this.movimientosObraSelected.idProveedores = this.movimientosObraSelected.proveedores.idProveedores;
      this.movimientosObraSelected.idInversionistas = null;
    }
    if(this.movimientosObraSelected.conceptos.traspaso == 1){
      this.movimientosObraSelected.tipoMovimiento = 4;
    }

    console.log('data to save ', this.movimientosObraSelected);

    this.movimientosObraProyeccionesService.createMovimientosObra(this.movimientosObraSelected)
        .subscribe(response => {
          const respuesta = response.json();
          this.processing = false;
          if (respuesta.success) {
            this.successModal.open({
              'title': 'Movimiento de obra-proyección guardado',
              'description': 'Se guardaron correctamente los datos del movimiento de obra'
            });
            this.movimientosObraSelected.folio = respuesta.content.folio;
            this.movimientosObraSelected.idMovimientos = respuesta.content.id;
            this.movimientosObraSelected.importeLetras = respuesta.content.importeLetras;
            this.isNew = true;
            this.goPage(1);
          }
        }, error => {
          this.processing = false;
          // se resuelven errores 403 y 500
          this.helperService.httpGlobalError(error, false);

          if (error.status == 400) {
            this.setBackendErrors(error.json().content);
          }

          if (error.status == 400 || error.status == 500) {
            this.warningModal.open({
              'title': 'ERROR',
              'description': 'No se completó la acción. Por favor, intente más tarde.'
            });
          }
        });
  }

  updateMovimientosObra() {
    this.errors = [];
    this.errors = this.movimientosObraProyeccionesService.validateMovimientosObra(this.movimientosObraSelected);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.processing = true;
    this.alterTable = 'starting';
    this.movimientosObraSelected.idCuentas = this.movimientosObraSelected.cuentas.idCuentas;
    this.movimientosObraSelected.idConceptos = this.movimientosObraSelected.conceptos.idConceptos;
    this.movimientosObraSelected.idObras = this.movimientosObraSelected.obras.idObras;
    this.movimientosObraSelected.numero = this.movimientosObraSelected.numero.toString();
    this.movimientosObraSelected.chequeCancelado = (this.movimientosObraSelected.chequeCancelado)? 1: 0;
    this.movimientosObraSelected.chequeConciliado = (this.movimientosObraSelected.chequeConciliado)? 1: 0;
    this.movimientosObraSelected.chequeTransferencia = (this.movimientosObraSelected.chequeTransferencia)? 1: 0;
    this.movimientosObraSelected.enviadoCfdi = (this.movimientosObraSelected.enviadoCfdi)? 1: 0;
    if (this.movimientosObraSelected.conceptos.traspaso == 1) {
      this.movimientosObraSelected.idCuentasDestino = this.movimientosObraSelected.cuenta_destino.idCuentas;
    } else if (this.movimientosObraSelected.conceptos.traspaso != 1 && this.validatorService.required(this.movimientosObraSelected.proveedores.idInversionistas)){
      console.log('se ha localizado inversionista ', this.movimientosObraSelected.proveedores.idInversionistas);
      this.movimientosObraSelected.idInversionistas = this.movimientosObraSelected.proveedores.idInversionistas;
      this.movimientosObraSelected.idProveedores = null;
    } else if (this.movimientosObraSelected.conceptos.traspaso != 1 && this.validatorService.required(this.movimientosObraSelected.proveedores.idProveedores)){
      console.log('se ha localizado proveedores', this.movimientosObraSelected.proveedores.idProveedores);
      this.movimientosObraSelected.idProveedores = this.movimientosObraSelected.proveedores.idProveedores;
      this.movimientosObraSelected.idInversionistas = null;
    }
    if(this.movimientosObraSelected.conceptos.traspaso == 1){
      this.movimientosObraSelected.tipoMovimiento = 4;
    }
    console.log('data to save ', this.movimientosObraSelected);

    this.movimientosObraProyeccionesService.updateMovimientosObra(this.movimientosObraSelected, this.movimientosObraSelected.idMovimientos)
        .subscribe(response => {
          this.processing = false;
          const respuesta = response.json();
          if (respuesta.success) {
            this.helperService.notification('Movimiento de obra guardado', 'Se guardaron correctamente los datos del movimiento de obra', 'success');
            this.movimientosObraSelected.folio = respuesta.content.folio;
            this.movimientosObraSelected.idMovimientos = respuesta.content.id;
            this.movimientosObraSelected.importeLetras = respuesta.content.importeLetras;
            this.isNew = false;
            this.goPage(this.currentPage);
          }
        }, error => {
          this.processing = false;
          // se resuelven errores 403 y 500
          this.helperService.httpGlobalError(error);

          if (error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        });
  }

  writePermission() {
    return this.movimientosObraProyeccionesService.writePermission();
  }

  canExport() {
    return this.movimientosObraProyeccionesService.canExport();
  }

  canSecurity() {
    return this.movimientosObraProyeccionesService.canSecurity();
  }

  confirmDeleteMovimientoObra() {
    this.confirmModal.open({
      'color': 'danger',
      'title': 'Eliminar movimiento',
      'description': '¡ATENCIÓN! <br> Está a punto de eliminar el movimiento de obra.',
      'callback': this.deleteMovimientoObra
    });
  }

  deleteMovimientoObra() {
    this.processing = true;
    this.movimientosObraProyeccionesService.deleteMovimientoObra(this.movimientosObraSelected.folio)
        .subscribe(
            response => {
              const movimientosObraDeleted = JSON.parse(JSON.stringify( this.movimientosObraSelected ));
              this.processing = false;
              this.successModal.open({
                'title': 'Movimiento eliminado',
                'description': 'El movimiento con datos: <br> Obra: ' + movimientosObraDeleted.obras.nombreObra + ' <br> Cuenta: ' + movimientosObraDeleted.cuentas.nombreCuenta + '<br> Ha sido eliminado.'
              });

              this.goPage(this.currentPage);
              this.resetMovimientosObraSelected();
            }, error => {
              this.processing = false;
              // se resuelven errores 403 y 500
              this.helperService.httpGlobalError(error, false);

              if (error.status == 400 || error.status == 500) {
                console.log('deleteMovimientoObra - error 400 ', error);
                this.warningModal.open({
                  'title': 'ERROR',
                  'description': 'No se completó la acción. Por favor, intente más tarde.'
                });
              }
            });
  }



  confirmDeleteMovimientoObraProyeccion(movimientoObra) {
    this.selectMovimientosObra(movimientoObra);
    if(this.validSendProyecciones())
      this.confirmModal.open({
        'color': 'success',
        'title': 'Mostrar movimiento de obra en proyecciones',
        'description': '¿Está seguro de mover el movimiento de obra a proyecciones?',
        'callback': this.sendMovimientosObraToProyecciones
      });
    else
      this.helperService.notification('ERROR', 'No se completó la acción solicitada. Permisos insuficientes.', 'error');
  }

  confirmAddMovimientoObraProyeccion(movimientoObra) {
    this.selectMovimientosObra(movimientoObra);
    if(this.validSendProyecciones())
      this.confirmModal.open({
        'color': 'success',
        'title': 'Agregar proyección de movimiento de obra',
        'description': 'Se agregará el registro proyectado a movimientos de obra.',
        'callback' : this.sendProyeccionesMovimientosObra
      });
    else
      this.helperService.notification('ERROR', 'No se completó la acción solicitada.  Permisos insuficientes.', 'error');
  }

    //proyecciones
  sendProyeccionesMovimientosObra() {
    
    this.movimientosObraProyeccionesService.sendProyeccionesToMovimientos(this.movimientosObraSelected)
        .subscribe(response => {
          this.processing = false;
          console.log("json", response.json().success);
          if (response.json().success) {
            this.helperService.notification('Movimiento de obra-proyecciones guardado', 'Se guardaron correctamente los datos del movimiento de obra', 'success');
            this.validEdit = false;
            this.movimientosObraSelected.proyeccionToMovimiento = 1;
            this.goPage(this.currentPage);
          }
        }, error => {
          this.processing = false;
          // se resuelven errores 403 y 500
          this.helperService.httpGlobalError(error);

          if (error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción solicitada. Por favor, intenta más tarde.', 'error');
          }
        });
  }

  sendMovimientosObraToProyecciones() {
    this.errors = [];
    this.errors = this.movimientosObraProyeccionesService.validateMovimientosObra(this.movimientosObraSelected);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.processing = true;
    this.movimientosObraSelected.idCuentas = this.movimientosObraSelected.cuentas.idCuentas;
    this.movimientosObraSelected.idConceptos = this.movimientosObraSelected.conceptos.idConceptos;
    this.movimientosObraSelected.idObras = this.movimientosObraSelected.obras.idObras;
    this.movimientosObraSelected.numero = this.movimientosObraSelected.numero.toString();
    this.movimientosObraSelected.chequeCancelado = (this.movimientosObraSelected.chequeCancelado)? 1: 0;
    this.movimientosObraSelected.chequeConciliado = (this.movimientosObraSelected.chequeConciliado)? 1: 0;
    this.movimientosObraSelected.chequeTransferencia = (this.movimientosObraSelected.chequeTransferencia)? 1: 0;
    this.movimientosObraSelected.enviadoCfdi = (this.movimientosObraSelected.enviadoCfdi)? 1: 0;
    if (this.movimientosObraSelected.conceptos.traspaso == 1) {
      this.movimientosObraSelected.idCuentasDestino = this.movimientosObraSelected.cuenta_destino.idCuentas;
    } else {
      this.movimientosObraSelected.idProveedores = this.movimientosObraSelected.proveedores.idProveedores;
    }
console.log("############# si entra al evento ###########");
    
    this.movimientosObraProyeccionesService.sendMovimientosObraToProyecciones(this.movimientosObraSelected)
        .subscribe(response => {
          this.processing = false;
          if (response.json().success) {
            this.helperService.notification('Movimiento de obra-proyecciones guardado', 'Se guardaron correctamente los datos del movimiento de obra', 'success');
            this.validEdit = true;
            console.log("##### El edittttttt hasta este momento es = ",this.validEdit);
            this.movimientosObraSelected.proyeccionToMovimiento = 0;
            this.goPage(this.currentPage);
          }
        }, error => {
          this.processing = false;
          // se resuelven errores 403 y 500
          this.helperService.httpGlobalError(error);

          if (error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción solicitada. Por favor, intenta más tarde.', 'error');
          }
        });
  }

  changeObraFilter($event) {
    this.obraFilter = $event;
    this.getCuentasFilter();
  }

  changeObraSelected() {

    if (this.movimientosObraSelected && this.movimientosObraSelected.obras.idObras) {
      // cuentasFilter
      this.cuentasService.getCuentasByObraToSelect(this.movimientosObraSelected.obras.idObras, '/movimientos')
        .subscribe((response) => {
          this.cuentasSelectedOptions = response.json().content;
      });

      const proveedoresSelectedOptions = [];
      this.proveedoresSelectedOptions = [];
      this.proveedoresService.getProveedoresAndInversionistas(this.movimientosObraSelected.obras.idObras, '/movimientos')
      .subscribe((response) => {
        const respuesta = response.json();
        proveedoresSelectedOptions.push({
          'text': 'Proveedores',
          'children': respuesta.content.proveedores,
          'key': 'idProveedores',
          'label': 'nombre'
        });
        proveedoresSelectedOptions.push({
          'text': 'Inversionistas',
          'children': respuesta.content.inversionistas,
          'key': 'idInversionistas',
          'label': 'nombre'
        });
        this.proveedoresSelectedOptions = proveedoresSelectedOptions;
      }, error => {
        this.proveedoresSelectedOptions = proveedoresSelectedOptions;
      });
      
    }

  }

  changeTipoMovimiento(tipoMovimiento) {
    // formateando búsqueda, si es traspaso, y asignando el nuevo tipo de movimiento al movimiento seleccionado.
    if (tipoMovimiento == 4) {
      this.movimientosObraSelected.conceptos.traspaso = 1;
    } else {
      this.movimientosObraSelected.tipoMovimiento = tipoMovimiento;
      this.movimientosObraSelected.conceptos.traspaso = 0;
    }
    
    this.conceptosService.getConceptosByTipoMovimientoToSelect(tipoMovimiento, '/movimientos')
        .subscribe((response) => {
          this.conceptosSelectedOptions = response.json().content;
        });
  }

  changeConceptoSelected(conceptoSelected) {

    conceptoSelected.traspaso = (conceptoSelected.tipo == 4)? 1: 0;
    this.movimientosObraSelected.conceptos = conceptoSelected;
  }

  isTipoMovimiento( tipoMovimiento ) {
    if (!this.validatorService.required(this.movimientosObraSelected)) {
      return false;
    }
    if (tipoMovimiento == 4 && this.movimientosObraSelected.conceptos.traspaso == 1) {
      return true;
    }
    if (tipoMovimiento == this.movimientosObraSelected.tipoMovimiento && this.movimientosObraSelected.conceptos.traspaso != 1) {
      return true;
    }
    return false;
  }

  imprimirRecibo() {
    this.printReciboModal.open();
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];

    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  movimientosObraSelectedWithId(){
    if(! this.movimientosObraSelected)
      return false;

    return (this.validatorService.required(this.movimientosObraSelected.idMovimientos));
  }

  cancelarMovimientosObraSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetMovimientosObraSelected
    });
  }


  getFilters() {
    // obraFilter
    this.obrasService.getObratoSelect('/movimientos')
        .subscribe((response) => {
          this.obraFilterOptions = response.json().content;
        });

    this.getCuentasFilter();

    // conceptosFilter
    this.conceptosService.getConceptostoSelect('/movimientos')
        .subscribe((response) => {
          this.conceptosFilterOptions = response.json().content;
        });

    // proveedoresFilter
    const proveedoresFilterOptions = [];
    this.proveedoresService.getProveedoresAndInversionistas(null, '/movimientos')
        .subscribe((response) => {
          const respuesta = response.json();
          proveedoresFilterOptions.push({
            'text': 'Proveedores',
            'children': respuesta.content.proveedores,
            'key': 'idProveedores',
            'label': 'nombre'
          });
          proveedoresFilterOptions.push({
            'text': 'Inversionistas',
            'children': respuesta.content.inversionistas,
            'key': 'idInversionistas',
            'label': 'nombre'
          });
          this.proveedoresFilterOptions = proveedoresFilterOptions;
        }, error => {
          this.proveedoresFilterOptions = proveedoresFilterOptions;
        });

    // tipoProveedoresFilter
    this.proveedoresService.getTiposProveedortoSelect('/movimientos')
        .subscribe((response) => {
          this.tipoProveedorFilterOptions = response.json().content;
        });
  }

  getCuentasFilter() {
    this.cuentasFilter = [];
    if(this.obraFilter !== undefined && !$.isEmptyObject(this.obraFilter)) {
      this.cuentasService.getCuentasByObraToSelect(this.obraFilter.idObras, '/movimientos')
          .subscribe((response) => {
            this.cuentasFilterOptions = response.json().content;
          });
    } else {
      this.cuentasService.getCuentastoSelect('/movimientos')
        .subscribe((response) => {
          this.cuentasFilterOptions = response.json().content;
          this.cuentasFilterOptionsTraspasos = response.json().content;
        });
    }
  }
  getTipoMovimiento( movimiento ) {
    if (movimiento.conceptos.traspaso == 1) {
      return 'TRASPASO';
    }

    return (movimiento.tipoMovimiento == 2) ? 'INGRESO' : 'EGRESO';
  }
  getFiltersData() {
    return {
      'obraFilter': this.obraFilter,
      'cuentasFilter': this.cuentasFilter,
      'conceptosFilter': this.conceptosFilter,
      'proveedoresFilter': this.proveedoresFilter,
      'tipoProveedorFilter': this.tipoProveedorFilter,
      'fechaInicial': this.fechaInicialFilter,
      'fechaFinal': this.fechaFinalFilter
    };
  }

  filter(page = null) {

    if (this.searchProcess) {
      this.searchProcess.unsubscribe();
    }

    if ( this.searchText && this.searchText.length > 1) {
      this.searchMovimientosObra();
      return false;
    }

    this.getTotales();
    this.searchProcess = this.movimientosObraProyeccionesService.getMovimientosObraWithFilters(this.getFiltersData(), page)
        .subscribe(response => {
          const content = response.json().content;
          this.movimientosObra = content.data;
          this.searchProcess = false;
          this.startPaginate(content);

          this.alterTable = (this.movimientosObra.length > 0)? false: 'not_found';
        });

  }

  hasFilter() {
    const hasFilter = ( !$.isEmptyObject(this.obraFilter) ||
                        this.validatorService.required(this.cuentasFilter) ||
                        this.validatorService.required(this.conceptosFilter) ||
                        this.validatorService.required(this.proveedoresFilter) ||
                        !$.isEmptyObject(this.tipoProveedorFilter));
    return hasFilter;
  }

  exportCSV() {
    this.exportingCSV = true;
    this.movimientosObraProyeccionesService.exportCSV(this.getFiltersData())
      .subscribe((response) => {
        this.exportingCSV = false;
      }, (error) => {
        // se resuelven errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  // SEGURITY MODULE
  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.securityActived = false;
            this.goPage(1);
            this.changeObraSelected();
            this.getCuentasFilter();
            this.resetMovimientosObraSelected();
          }
        });
    }
  
  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.movimientosObraProyeccionesService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if(respuesta.success === true) {
          this.goPage(1);
          this.getCuentasFilter();
          this.changeObraSelected();
          this.securityModal.close();
          this.securityActived = true;
          this.securityModal.push({
            'passwordActivated': true
          });
          this.resetMovimientosObraSelected();
        }
      }, (error) => {
        this.securityModal.loading = false;
        // se resuelven errores 403 y 500
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
          this.securityActived = false;
          this.securityModal.push({
            'passwordActivated': false
          });
      })
  }

  isTraspasoIngreso(movimientoObra) {

    if (!movimientoObra.conceptos) {
      return false;
    }
    const isTraspasoIngreso = (movimientoObra.conceptos.traspaso == 1 && movimientoObra.tipoMovimiento == 2)? true: false;
    return isTraspasoIngreso;
  }

  // MODAL FUNCTIONS

  modalCallback(callback){
    callback();
  }

  // MAIN SECTIONS FUNCTIONS

  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for (let i = 1; i <= this.paginate.last_page; i++) {
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {
    if (this.searchText) {
      this.searchMovimientosObra(page);
    } else {
      this.getMovimientosObra(page);
    }
  }

  changeSwitchListado(){
    if(!this.mostrarListado){
      this.movimientosObraSelected = this.movimientosObraProyeccionesService.getDefaultSchedule();
    }
  }

  validEditAndDeleteMovimiento()
  {
    console.log("Antes de todas las validaciones = ",this.validEdit);
    if(this.movimientosObraSelected.proyeccionToMovimiento == 1)
    {
      this.validEdit = false;
    }
    else
      if (this.movimientosObraSelected.conceptos.traspaso == 1) {
        if((this.movimientosObraSelected.idCuentasDestino !== null && (this.movimientosObraSelected.cuentas === null || this.movimientosObraSelected.cuenta_destino === null)) && this.isNew == false)
        {
          this.validEdit = false;
          console.log("###### Entra al validador = ");
        }
        else
          this.validEdit = true;
      }
      else
      {
        if(this.movimientosObraSelected.proyeccionToMovimiento == 0)
        {
          this.validEdit = true;
        }
      }
    console.log("El validar editar es lo siguiente = ",this.validEdit);
    //this.validEdit;
  }

  validSendProyecciones()
  {
    var valid = true;
    if(this.movimientosObraSelected !== undefined)
      if (this.movimientosObraSelected.conceptos.traspaso == 1) {
        if((this.movimientosObraSelected.idCuentasDestino !== null && (this.movimientosObraSelected.cuentas === null || this.movimientosObraSelected.cuenta_destino === null)) && this.isNew == false)
        {
          valid = false
        }
      }
    return valid;
  }
  
  showPrintModal(){
    var data = {
      searchText : this.searchText,
      filterData : this.getFiltersData(),
      obraFilterOptions: this.obraFilterOptions,
      cuentasFilterOptions: this.cuentasFilterOptions,
      conceptosFilterOptions: this.conceptosFilterOptions,
      proveedoresFilterOptions: this.proveedoresFilterOptions,
    };
    var isProyecciones = true;
    this.movimientosModal.open(data,isProyecciones);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/movimientos-obra-proyecciones/movimientos-obra-proyecciones.component.ts